<template>
    <div class="monitor-wrap">
        <dv-scroll-board :config="tableConfig" ref="scrollBoard"/>
        <!-- <table class="panel-table" bordercolor="#0d48e0" border="1">
            <thead bgcolor="#0e4ae0" align="center" >
            <tr height="40">
                <th colspan="6"><img src="./images/icon04.png" /> 监控列表</th>
            </tr>
            </thead>
            <tbody>
            <tr class="aaa" align="center">
            <td v-for="(item,index) in factoryHeader" :key="index" style="color: #00fcff; font-size: 18px; padding: 5px 0;">{{ item.categories }}</td>
            </tr>
            <tr v-for="(y,index) in factory.slice(0,6)" :key="index" class="aaa" style="font-size: 16px;" align="center" >
                <td>{{ y.company }}</td>
                <td>{{ y.dtuCnt }}</td>
                <td>{{ y.plcCnt }}</td>
                <td>{{ y.dataCnt }}</td>
                <td>{{ y.alarm }}</td>
                <td width="250">
                    <button class="b1 click_pop">报警记录</button>
                    <button class="b2 click_pop2">历史数据</button>
                </td>
            </tr>
            </tbody>
        </table> -->
    </div>
</template>
<script>
import Vue from "vue"
import { scrollBoard } from '@jiaminghi/data-view'

Vue.use(scrollBoard)

import {realData} from "@api/realTimeForm"


export default {
    name:"monitor",
    data(){
        return {
            tableConfig:{
                header:['站点编号',"站点编号","时间","瞬时流量","累积流量"],
                data:[
                    ["宝钢",200,400,5000,"无"],
                    ["宝钢",200,400,5000,"无"],
                    ["宝钢",200,400,5000,"无"],
                    ["宝钢",200,400,5000,"无"],
                    ["宝钢",200,400,5000,"无"],
                    ["宝钢",200,400,5000,"无"],
                    ["宝钢",200,400,5000,"无"],
                    ["宝钢",200,400,5000,"无"],
                    ["宝钢",200,400,5000,"无"],
                ],
                align:['center', 'center', 'center','center', 'center']
            },
            factoryHeader:[
                {"categories":"站点编号"},
                {"categories":"站点编号"},
                {"categories":"时间"},
                {"categories":"瞬时流量"},
                {"categories":"累积流量"},
                {"categories":"报警"},
            ],
            factory:[
                {"company":"宝钢","dtuCnt": 200, "plcCnt": 400,"dataCnt": 5000,"alarm": "无"},
                {"company":"造纸厂","dtuCnt": 3000,"plcCnt": 2000,"dataCnt": 1000,"alarm": "无"},
                {"company":"锅炉厂","dtuCnt": 1500,"plcCnt": 1000,"dataCnt": 500,"alarm": "无"},
                {"company":"锅炉二厂","dtuCnt": 1500,"plcCnt": 300,"dataCnt": 1200,"alarm": "温度上限报警>120"},
                {"company":"锅炉三厂","dtuCnt": 1000,"plcCnt": 800,"dataCnt": 200,"alarm": "无"},
                {"company":"锅炉三厂","dtuCnt": 1000,"plcCnt": 800,"dataCnt": 200,"alarm": "无"},
                {"company":"锅炉三厂","dtuCnt": 1000,"plcCnt": 800,"dataCnt": 200,"alarm": "无"},
                {"company":"锅炉三厂","dtuCnt": 1000,"plcCnt": 800,"dataCnt": 200,"alarm": "无"},
                {"company":"锅炉三厂","dtuCnt": 1000,"plcCnt": 800,"dataCnt": 200,"alarm": "无"},
                {"company":"锅炉三厂","dtuCnt": 1000,"plcCnt": 800,"dataCnt": 200,"alarm": "无"}		
            ]
        }
    },
    methods:{
        // 获取实时数据
        getRealTime(){

        },
        // 获取实时数据
        async handleGetCurentData() {
            let that=this;
            // 判断当前路由是否为智慧管网，如果不是，则应该取消定时器
            if(this.$route.name!="realTimeForm"){
                // 取消定时器
                if(that.currentTimeId){
                    clearTimeout(that.currentTimeId);
                    that.currentTimeId=null;
                }
                // console.log("未选中任何站点");
                return;
            }
            // 还有可能出现站点列表为空的情况,那就重新初始化
            if(!that.selectStr){
                this.$message({
                message:"未选中任何站点",
                type:"warning",
                });
                return;
            }
            let data = await realData(that.selectStr);
            // 保存实时数据
            that.currentDatasList = data;

            // 定时器调用实时数据
            if(!that.currentTimeId){
                that.timingCurrentData();
            }
        },
    }
}
</script>
<style lang="scss">
.monitor-wrap{
    width:100%;
    height: 100%;
    .panel-table {
        text-align: left;color: #ccc;
        margin: 0 auto !important;
        width: 96%;	margin-top: 20px !important;
        padding: 0.5rem 0 !important;
        font-size: 1.2rem;
    }

    tr.aaa:hover{background: #1d3152; cursor: pointer;}
    .b1{width: 70px; height: 25px; background: #FF0000; cursor: pointer; color: #FFFFFF; border: none; border-radius:3px ;}
    .b2{width: 70px; height: 25px; background: #2897c4; cursor: pointer; color: #FFFFFF; border: none; border-radius:3px ;}
    .b3{width: 70px; height: 25px; background: #36791a; cursor: pointer; color: #FFFFFF; border: none; border-radius:3px ;}
}
</style>